import Macy from 'macy';

export function macy() {
	const macyContainer = document.querySelector('.js-macy');

	if (macyContainer) {
		var macy = Macy({
			container: '.js-macy',
			trueOrder: true,
			waitForImages: true,
			margin: 32,
			columns: 4,
			breakAt: {
				1200: 3,
				768: 2,
				480: 1
			}
		});
	}
}